document.addEventListener('alpine:init', () => {
    Alpine.data('shopfilters', () => ({
        open: false,
        breakpoint: 768,
        init() {
            this.resized()
        },
        openFilters() {

            // Always enabling for larger screen prevents a resize issue where the scroll can get locked
            if (window.innerWidth <= this.breakpoint) {
                this.disableBodyScroll()
            } else {
                this.enableBodyScroll()
            }

            if (this.open) {
                return
            }

            this.open = true
        },
        closeFilters() {
            if (!this.open) {
                return
            }

            this.open = false
            this.enableBodyScroll()
            const topPosition = document.getElementsByClassName('woocommerce-notices-wrapper')[0].offsetTop
            window.scrollTo({
                top: topPosition - 50,
                behavior: 'smooth'
            })
        },
        toggleFilters(e) {
            if (this.open) {
                this.closeFilters()
            } else {
                this.openFilters()
            }
        },
        resized() {
            if (window.innerWidth > this.breakpoint) {
                this.openFilters()
            } else {
                this.closeFilters()
            }
        },
        disableBodyScroll() {
            document.body.classList.add('no-scroll')
        },
        enableBodyScroll() {
            document.body.classList.remove('no-scroll')
        }
    }))
})
